module.exports = __webpack_public_path__ + "img/mapped_file_uploaded_success.89cce9e0.svg";